/**
 * Contoroller
 * Viewの変更を受けてModelのactionを呼ぶ
 * @param {auth} model
 */
export default function AuthController(model) {
  return {
    'showAuth': () => {
      model.action('showAuthView')
    },
    'input': (type, val) => {
      switch(type) {
        case 'YY':
          model.action('birthYearSelected', val)
          break

        case 'MM':
          model.action('birthMonthSelected', val)
          break

        case 'DD':
          model.action('birthDaySelected', val)
          break

        case 'Country':
          model.action('countrySelected', val)
          break

        case 'Remember':
          model.action('rememberChecked', val)
      }
    },
    'setAge': (type, val) => {
      model.action('setUserAge', val)
    },
    'setDrinkingAge': (type, val) => {
      model.action('setUserDrinkingAge', val)
    },
    'verify': (type, val) => {
      model.action('setPermission', val)
    },
    'submit': () => {
      model.action('submitAuth')
    },
    'setAnnotationVisibility': () => {
      model.action('annotationVisible')
    },
    'clearInputData': () => {
      model.action('clearUserData')
    }
  }
}



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/auth/controllers/authController.js
 **/